import {BrowserRouter} from 'react-router-dom';
import RoutesProvider from './routes';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: false, v7_relativeSplatPath: false }}>
      <RoutesProvider />
    </BrowserRouter>
  );
}

export default App;
